import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";

export function isPropertyFavouriteButtonAvailable(property: IPropertyDetail) {
    const isForSale = property.offer.configuration.display_type === OfferDisplayType.FOR_SALE && property.for_sale;
    const isPlanned = property.offer.configuration.display_type === OfferDisplayType.PLANNED;
    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;

    return (isPlanned || isForSale) && isPublished;
}
import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {PropertyDisplayType} from "../types/PropertyDisplayType";

export function isPropertyFavouriteButtonAvailable(property: IPropertyDetail) {
    const isForSale = property.offer.configuration.display_type === OfferDisplayType.FOR_SALE && property.for_sale;
    const isPlanned = property.offer.configuration.display_type === OfferDisplayType.PLANNED;
    const isPublished = property.configuration.display_type === PropertyDisplayType.PUBLISHED;

    return (isPlanned || isForSale) && isPublished;
}
